// Auto-generated TypeScript enum with enhanced data
// Generated from: vortex\ServicesV2\Messages\DataProviders\MessageDataField
// Generated on: 2025-10-18 08:47:06

export enum MessageDataField {
  BODY = 'messageBody',
  SUBJECT = 'messageSubject',
}

export const MessageDataFieldGetCasts = {"messageBody": "string", "messageSubject": "string"} as const;

export const MessageDataFieldGetTemplate = {"messageBody": "", "messageSubject": ""} as const;

export const MessageDataFieldCases = ["messageBody", "messageSubject"] as const;
